import React, { useState, useEffect } from 'react';
import coreXSystemImage from '../images/CoreXSystemLogo.png';
import backgroundImage from "../images/Background.png";
import styles from './IntroPages.module.css';
import corexasLogoWithText from "../images/CorexasLogoWithText.png";
import { getLanguageBasedImage } from '../languageutil/ImageUtil';

function CompanyTypeSelectPage({ navigate }) {
  const [newCompanyButton, setNewCompanyButton] = useState(null);
  const [savedCompanyButton, setSavedCompanyButton] = useState(null);

  useEffect(() => {
    setNewCompanyButton(getLanguageBasedImage('YeniSirketButton.png'));
    setSavedCompanyButton(getLanguageBasedImage('KayitliSirketButton.png'));
  }, []);

  return (
    <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Bookman Old Style", flexDirection: "column", justifyContent: "start" }}>
      <img src={coreXSystemImage} alt="CoreXFuture" style={{ marginLeft: "2vw", height: "25vh", marginTop: "5vh", alignSelf: "start" }} />
      <div className={styles.content} style={{ height: "50vh", display: "flex", alignItems: "center" }}>
        <div className={styles.leftside} style={{ height: "auto", justifyContent: "normal" }}>
          <div className={styles.buttoncontainer} style={{ display: "flex", justifyContent: "end", marginRight: "3vw" }}>
            <img src={savedCompanyButton} alt="Saved Company" className={styles.startbutton} style={{ width: "40vw" }} onClick={() => { navigate("/entercompanyname/saved"); }} />
          </div>
        </div>
        <div className={styles.leftside} style={{ height: "auto", justifyContent: "normal" }}>
          <div className={styles.buttoncontainer} style={{ display: "flex", justifyContent: "start", marginLeft: "3vw" }} >
            <img src={newCompanyButton} alt="New Company" className={styles.startbutton} style={{ width: "40vw" }} onClick={() => { navigate("/entercompanyname/new"); }} />
          </div>
        </div>
      </div>
      <img src={corexasLogoWithText} alt="CoreXFuture" style={{ position: "absolute", height: "10vh", maxHeight: "50px", bottom: "5vh" }} />
    </div>
  );
}

export default CompanyTypeSelectPage;